const educationtype = {
    UNIVERSITY: 1,
    PROFESSIONAL: 2,
    INFORMAL: 3,
    OTHER: 4
}

const educationtypeOption = [
    {
        type: educationtype.UNIVERSITY,
        name: "University / Institute"
    },
    {
        type: educationtype.PROFESSIONAL,
        name: "Professional Certification"
    },
    {
        type: educationtype.INFORMAL,
        name: "Informal Certification"
    },
    {
        type: educationtype.OTHER,
        name: "Other"
    }
]

const degree = {
    DIPLOMA_ONE: 2,
    DIPLOMA_THREE: 3,
    BACHELOR: 4,
    MASTER: 5,
    DOCTORATE: 6
}

const degreeOption = [
    {
        degree: degree.DIPLOMA_ONE,
        name: "Diploma 1"
    },
    {
        degree: degree.DIPLOMA_THREE,
        name: "Diploma 3"
    },
    {
        degree: degree.BACHELOR,
        name: "Bachelor (S1)"
    },
    {
        degree: degree.MASTER,
        name: "Master (S2)"
    },
    {
        degree: degree.DOCTORATE,
        name: "Doctorate (S3)"
    }
]

const noticePeriod = {
    IMMEDIATELY: 2,
    LESS_THAN_TWO_WEEKS: 3,
    ONE_MONTH: 4,
    MORE_THAN_ONE_MONTH: 5
}

const noticePeriodOption = [
    {
        notice: noticePeriod.IMMEDIATELY,
        name: "Immediately"
    },
    {
        notice: noticePeriod.LESS_THAN_TWO_WEEKS,
        name: "< 2 weeks"
    },
    {
        notice: noticePeriod.ONE_MONTH,
        name: "1 month"
    },
    {
        notice: noticePeriod.MORE_THAN_ONE_MONTH,
        name: "> 1 month"
    }
]

const referral = {
    WEBSITE: 2,
    JOBSTREET: 3,
    EMPLOYEE: 4,
    OTHER: 5
}

const referralOption = [
    {
        referral: referral.WEBSITE,
        name: "DevStack Website"
    },
    {
        referral: referral.JOBSTREET,
        name: "Jobstreet"
    },
    {
        referral: referral.EMPLOYEE,
        name: "DevStack employee (or ex)"
    },
    {
        referral: referral.OTHER,
        name: "Other"
    },
]

const application_step = {
    PERSONAL: 0,
    EXPERIENCES: 1,
    EDUCATION: 2,
    ADDITIONAL: 3
}

const project = {
    periodStart: "",
    periodEnd: "",
    techs: "",
    description: "",
    roles: ""
}

const employment = {
    companyName: "",
    isCurrent: false,
    periodStart: "",
    periodEnd: "",
    jobTitle: "",
    jobDesc: "",
    salary: 0,
    projects: [
        project
    ]
}

const education = {
    type: educationtype.UNIVERSITY,
    university: "",
    major: "",
    degree: degree.DIPLOMA_ONE,
    periodStart: "",
    periodEnd: "",
    gpa: 0,
    final: "",
    ceritificateName: "",
    receivedDate: ""
}

export const jobApplySteps = {
    validateInformation: "validateInformation",
    validateExperiences: "validateExperiences",
    validateEducation: "validateEducation",
    validateAdditional: "validateAdditional",
}

export default {
    educationtype,
    educationtypeOption,
    degree,
    degreeOption,
    noticePeriod,
    noticePeriodOption,
    referral,
    referralOption,
    application_step,
    project,
    employment,
    education
};


// WEBPACK FOOTER //
// ./src/config/constanta.js